import './AdInfo.less';
import {
  Row,
  Col,
  Divider,
  // Card,
  // Button,
  // Grid,
  Collapse,
} from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
// import { isLocaleEnglish } from 'utils/languageUtils';
import Email from 'assets/images/policy/Email.svg';
import Phone from 'assets/images/policy/Phone.svg';
import Whatsapp from 'assets/images/policy/Whatsapp.svg';

const { Panel } = Collapse;
// import ChevronRight from 'assets/images/home/chevron-right.svg';
import ArrowClose from 'assets/images/home/arrow-close.svg';
import ChevronUp from 'assets/images/home/chevron-up.svg';
import { Consultant } from 'all-in-one-shared-api/dist/apis/policy/useLifePolicyDetail';

interface AdinfoProps {
  adinfo?: Consultant;
  salesUnitCode?: string;
}
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
const StyledBlock = styled.div`
  width: 100%;
  background: #fff;
  margin-bottom: 1rem;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 672px;
  margin: 0 auto;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  // margin: 0 16px;
`;
const AntDivider = styled(Divider)`
  border-color: #cccccc;
  margin: 16px 0;
`;

const AdInfo = ({ adinfo, salesUnitCode }: AdinfoProps): JSX.Element => {
  const { t } = useTranslation();
  // const isEnglish = isLocaleEnglish(i18n.language);
  // const handleInsureName = () => {
  //   if (['B2B2C', 'RTLIF', 'HGHNW'].includes(salesUnitCode || '')) {
  //     return 'servicing agent';
  //   } else if (salesUnitCode) {
  //     return 'TR';
  //   } else {
  //     return adinfo?.intermediaryName;
  //   }
  // };
  const handlePhoneDom = () => {
    if (
      (adinfo?.officeCountryCode && adinfo?.officeContactNumber) ||
      (adinfo?.phoneNumberCountryCode && adinfo?.telephone)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handleWhatsappShow = () => {
    if (
      adinfo?.phoneNumberCountryCode &&
      adinfo?.telephone &&
      !(salesUnitCode == 'RTLIF' || salesUnitCode == 'HGHNW')
    ) {
      return true;
    } else return false;
  };
  const handlePhoContent = () => {
    if (adinfo?.telephone) {
      return adinfo?.phoneNumberCountryCode + ' ' + adinfo?.telephone;
    } else if (adinfo?.officeContactNumber) {
      return adinfo?.officeCountryCode + ' ' + adinfo?.officeContactNumber;
    }
  };
  const openEmail = (email?: string) => {
    if (email) window.location.href = `mailto:${email}`;
  };
  const openPhone = (phone?: string) => {
    if (phone) window.location.href = `tel:${phone?.replace(/[\s()+-]/g, '')}`;
  };
  const openWhatsApp = (phone?: string) => {
    if (phone) {
      const whatsAppUrl = `https://wa.me/${phone}`;
      window.location.href = whatsAppUrl;
      console.log(whatsAppUrl);
    }
  };
  const ExpandContent = () => {
    return (
      <div>
        <div className="adinfo-content">
          <Androw justify="start">
            <AndCol>
              <div className="tagging">
                <span className="font-size17  grey-font">{t('life.policies.ContactInsurance')}</span>
              </div>
            </AndCol>
          </Androw>
          <Androw
            justify="start"
            style={{
              marginTop: '16px',
              backgroundColor: '#fff',
              borderRadius: '16px',
              padding: '16px 16px',
              boxShadow: '0px 2px 4px 0px #00000033',
              marginBottom: '24px',
            }}
          >
            {adinfo?.intermediaryName && (
              <AndCol>
                <span className="font-size22">{adinfo?.intermediaryName}</span>
              </AndCol>
            )}
            {adinfo?.emailAddress && (
              <>
                <AntDivider></AntDivider>
                <AndCol style={{ width: '100%' }}>
                  <Androw justify="space-between" align="middle" onClick={() => openEmail(adinfo?.emailAddress)}>
                    <AndCol>
                      <p className="font-setting500 font-size17 grey-font p-bottom">
                        {t('life.policies.EmailAddress')}
                      </p>
                      <p className="font-size17 p-bottom">{adinfo?.emailAddress}</p>
                    </AndCol>
                    <AndCol>
                      <img src={Email} alt="" style={{ cursor: 'pointer' }} />
                    </AndCol>
                  </Androw>
                </AndCol>
              </>
            )}
            {handlePhoneDom() && (
              <>
                <AntDivider></AntDivider>
                <AndCol style={{ width: '100%' }}>
                  <Androw justify="space-between" align="middle">
                    <AndCol>
                      <p className="font-setting500 font-size17 grey-font p-bottom">{t('life.policies.PhoneNumber')}</p>
                      <p className="font-size17 p-bottom">{handlePhoContent()}</p>
                    </AndCol>
                    <AndCol>
                      <img
                        src={Phone}
                        alt=""
                        style={{ cursor: 'pointer' }}
                        onClick={() => openPhone(handlePhoContent())}
                      />
                      {handleWhatsappShow() && (
                        <img
                          src={Whatsapp}
                          alt=""
                          style={{ marginLeft: '40px', cursor: 'pointer' }}
                          onClick={() => openWhatsApp(handlePhoContent())}
                        />
                      )}
                    </AndCol>
                  </Androw>
                </AndCol>
              </>
            )}
          </Androw>
        </div>
      </div>
    );
  };
  return (
    <div className="beneficiaries-wrapper">
      <StyledBlock>
        <Androw justify="start">
          <AndCol style={{ width: '100%' }}>
            <Collapse
              className="font-size26 grey-font"
              style={{ backgroundColor: '#fff' }}
              collapsible="header"
              bordered={false}
              expandIconPosition="end"
              expandIcon={({ isActive }) => {
                return isActive ? <img src={ChevronUp} /> : <img src={ArrowClose} />;
              }}
            >
              <Panel header={t('life.policies.InsuranceAdvisor')} key="1" className="grey-font">
                <ExpandContent></ExpandContent>
              </Panel>
            </Collapse>
          </AndCol>
        </Androw>
      </StyledBlock>
    </div>
  );
};

export default AdInfo;
